export const required = value => (value && /\S/i.test(value) ? undefined : 'Required');

export const ext = value => (value && Number.isNaN(Number(value)) ? 'Invalid extension' : undefined);

export const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(value) ? 'Invalid email address' : undefined;

export const validateTimePeriod = params => {
  const value = params && params.value ? params.value : params;
  return value === 'AM' || value === 'PM' ? undefined : 'Not a valid time period.';
};

export const isNumber = params => {
  const value = params && params.value ? params.value : params;
  return /^\d+$/.test(value) ? undefined : 'Not a number.';
};
